import React, { useContext } from 'react';

export type ILogger = {
    event: {
        trackEvent: (eventName: string, data?: unknown) => void;
    };
    jsError?: {
        logJsErr?: (error: string) => void;
    };
};

const DEFAULT_LOGGER: ILogger = {
    event: {
        trackEvent: () => undefined,
    },
};

const getLogger = (): ILogger => {
    return {
        event: {
            trackEvent: (_eventName: string, _data?: unknown) => {
                return undefined;
            },
        },
        jsError: {
            logJsErr: (_error: string) => {
                return undefined;
            },
        },
    };
};

export const LOGGER = getLogger();

export const LoggerContext = React.createContext<ILogger>(DEFAULT_LOGGER);

export const useLogger = () => useContext(LoggerContext);
